import React from "react";

import { ConfirmationModal } from "src/base-components/ConfirmationModal";
import { BeMappedNode } from "src/constants/NodeDataTypes";
import { renderBranchNodes } from "src/splitNodeEditor/SplitNodeDeletionModalContent";

export type ConfirmationModalProps = {
  open: boolean;
  onClose: () => void;
  onConfirmDelete: () => void;
  branchToDeleteName: string;
  branchToDeleteId?: string;
  branchCount?: number;
  nodesToDelete: BeMappedNode[];
};

export const SplitBranchDeletionModal: React.FC<ConfirmationModalProps> = ({
  open,
  onClose,
  branchToDeleteId,
  branchCount = 1,
  nodesToDelete,
  onConfirmDelete,
}) => {
  const isMultipleBranches = branchCount > 1;

  // Filter out branch node by ID if provided (for manual deletion).
  // For copilot path, nodesToDelete is already pre-filtered.
  const nodesDownstream = branchToDeleteId
    ? nodesToDelete.filter((node) => node.id !== branchToDeleteId)
    : nodesToDelete;

  const renderDeleteMessage = () => (
    <div className="font-inter-normal-12px text-gray-500">
      Are you sure you want to delete{" "}
      {isMultipleBranches ? `these ${branchCount} Branches` : "this Branch"}?
      This action cannot be undone.{" "}
      {nodesDownstream.length !== 0 &&
        "The following Nodes downstream will also be deleted:"}
    </div>
  );

  return (
    <ConfirmationModal
      children={
        nodesDownstream.length !== 0 && (
          <>{renderBranchNodes(nodesDownstream)}</>
        )
      }
      description={renderDeleteMessage()}
      open={open}
      title={
        isMultipleBranches
          ? `Delete ${branchCount} Branches?`
          : "Delete Branch?"
      }
      onClose={onClose}
      onConfirm={onConfirmDelete}
    ></ConfirmationModal>
  );
};
